import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../features/auth/useAuth';
import { PixelMark } from './pixel';

const NAV_ITEMS = [
  { to: '/', label: 'ภาพรวม', end: true },
  { to: '/holdings', label: 'สินทรัพย์', end: false },
  { to: '/realized', label: 'ขาย & ปันผล', end: false },
  { to: '/settings', label: 'ตั้งค่า', end: false },
] as const;

/** จุดสีท้ายหน้า — ไล่โทนเดียวกับแถบกราฟ ทำหน้าที่เป็นลายเซ็นของธีม */
const FOOTER_DOTS = ['bg-brand', 'bg-azure', 'bg-up', 'bg-warn', 'bg-down'];

export function AppLayout() {
  const { user, signOut } = useAuth();

  return (
    <div className="flex min-h-dvh flex-col">
      {/*
        หัวหน้าจอลอยค้างไว้พร้อมพื้นโปร่ง — เลื่อนดูรายการยาว ๆ แล้วยังสลับหน้าได้
        ต้องมีสีพื้นของตัวเองเสมอ ไม่ใช่โปร่งล้วน ไม่งั้นตัวหนังสือจะทับกับ content ที่ไหลผ่านใต้
      */}
      <header className="sticky top-0 z-10 border-b border-line bg-header/70 backdrop-blur-md">
        {/*
          ลำดับต่างกันสองจอ จึงสั่งด้วย `order` แทนการเรียงตาม DOM
          จอเล็ก: โลโก้กับปุ่มออกจากระบบอยู่แถวบนคู่กัน แล้วเมนูตกลงมาเต็มความกว้างแถวล่าง
          จอกว้าง: เรียงแถวเดียว โลโก้ → เมนู → ผู้ใช้ชิดขวา
        */}
        <div className="mx-auto flex max-w-[1240px] flex-wrap items-center gap-x-4 gap-y-3 px-4 py-3 sm:px-6">
          <div className="order-1 flex items-center gap-3">
            <PixelMark size={24} />
            <span className="font-pixel text-[13px] tracking-[0.5px] text-ink-100">PORTTANG</span>
          </div>

          <nav className="order-3 flex w-full flex-wrap gap-1.5 text-sm sm:order-2 sm:w-auto">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  [
                    'rounded-md px-3 py-1.5 transition',
                    isActive
                      ? 'bg-brand-soft font-semibold text-brand-text'
                      : 'text-ink-400 hover:bg-hover hover:text-ink-100',
                  ].join(' ')
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="order-2 ml-auto flex items-center gap-2 sm:order-3">
            <div className="flex items-center gap-2 rounded-lg border border-line-strong bg-surface py-1.5 pr-3 pl-1.5">
              <div className="size-6 rounded-[4px] bg-linear-to-br from-brand to-down" />
              <span className="hidden max-w-[16ch] truncate text-[13px] text-ink-200 sm:inline">
                {user?.email ?? user?.displayName}
              </span>
            </div>

            <button
              type="button"
              onClick={() => void signOut()}
              className="rounded-md border border-line-strong px-3 py-2 font-pixel text-[8px] text-ink-400 transition hover:border-brand hover:text-brand-text"
            >
              LOGOUT
            </button>
          </div>
        </div>
      </header>

      <main className="mx-auto w-full max-w-[1240px] grow px-4 py-6 sm:px-6">
        <Outlet />
      </main>

      <footer className="mx-auto flex w-full max-w-[1240px] flex-wrap items-center justify-between gap-3 px-4 py-6 font-mono text-[11px] text-ink-600 sm:px-6">
        <span>PORTTANG · รวมพอร์ตจากหลายแพลตฟอร์มมาดูที่เดียว</span>
        <span aria-hidden className="flex gap-1">
          {FOOTER_DOTS.map((color) => (
            <span key={color} className={`size-[7px] ${color}`} />
          ))}
        </span>
      </footer>
    </div>
  );
}
